export const posters = [
  {
    src: "/posters/affiche_grenoble.webp",
    original: "/posters/affiche_grenoble.webp",
    caption: "Affiche Grenoble",
  },
  {
    src: "/posters/Affiche_Minimisant_1.webp",
    original: "/posters/Affiche_Minimisant_1.webp",
    caption: "Affiche Minimistan",
  },
  {
    src: "/posters/Chartreuse.webp",
    original: "/posters/Chartreuse.webp",
    caption: "Chartreuse",
  },
  {
    src: "/posters/Imbiber.webp",
    original: "/posters/Imbiber.webp",
    caption: "Imbiber",
  },
  {
    src: "/posters/TheseLea.webp",
    original: "/posters/TheseLea.webp",
    caption: "Thèse",
  },

  {
    src: "/posters/MedusaJaune.webp",
    original: "/posters/MedusaJaune.webp",
    caption: "M",
  },
  {
    src: "/posters/JimmyB.webp",
    original: "/posters/JimmyB.webp",
    caption: "JimmyB",
  },

  {
    src: "/posters/Lakers.webp",
    original: "/posters/Lakers.webp",
    caption: "Black Mamba",
  },
  {
    src: "/posters/HeyJoe02.webp",
    original: "/posters/HeyJoe02.webp",
    caption: "Groupe de musique",
  },

  {
    src: "/posters/RaquetGang.webp",
    original: "/posters/RaquetGang.webp",
    caption: "Raquet Gang",
  },
  {
    src: "/posters/Singe01.webp",
    original: "/posters/Singe01.webp",
    caption: "JimmyB - Inspecteur",
  },
  {
    src: "/posters/heyJoe.webp",
    original: "/posters/heyJoe.webp",
    caption: "Groupe de musique",
  },
];

export const concepts = [
  {
    src: "/concepts/7_ville02.webp",
    original: "/concepts/7_ville02.webp",
    caption: "Becanile",
  },
  {
    src: "/concepts/9_Yael_graphique01.webp",
    original: "/concepts/9_Yael_graphique01.webp",
    caption: "Yael - veloboy",
  },
  {
    src: "/concepts/9_Yael_graphique02.webp",
    original: "/concepts/9_Yael_graphique02.webp",
    caption: "Yael - veloboy",
  },
  {
    src: "/concepts/CharaleaPri.webp",
    original: "/concepts/CharaleaPri.webp",
    caption: "Chara design",
  },
  {
    src: "/concepts/Classe.webp",
    original: "/concepts/Classe.webp",
    caption: "Classe pour film animation",
  },
  {
    src: "/concepts/DecorPrimaire.webp",
    original: "/concepts/DecorPrimaire.webp",
    caption: "Decore pour film animation",
  },
  {
    src: "/concepts/GareGRENOBLE.webp",
    original: "/concepts/GareGRENOBLE.webp",
    caption: "Gare de Grenoble - illustration",
  },
  {
    src: "/concepts/Plage.webp",
    original: "/concepts/Plage.webp",
    caption: "Plage",
  },
  {
    src: "/concepts/premierePage.webp",
    original: "/concepts/premierePage.webp",
    caption: "Velo boy - premiere page",
  },
  {
    src: "/concepts/image0001.webp",
    original: "/concepts/image0001.webp",
    caption: "Histoire d'objets",
  },
  {
    src: "/concepts/vueintsaloon.webp",
    original: "/concepts/vueintsaloon.webp",
    caption: "Saloon",
  },
  {
    src: "/concepts/Illustration_bedroom.webp",
    original: "/concepts/Illustration_bedroom.webp",
    caption: "Chambre - illustration",
  },
  {
    src: "/concepts/Personnages.webp",
    original: "/concepts/Personnages.webp",
    caption: "Histoire d'objets - Personnages",
  },
  {
    src: "/concepts/attitude02.webp",
    original: "/concepts/attitude02.webp",
    caption: "Chara design - attitude",
  },
  {
    src: "/concepts/attitude03.webp",
    original: "/concepts/attitude03.webp",
    caption: "Chara design - attitude",
  },
  {
    src: "/concepts/attitude04.webp",
    original: "/concepts/attitude04.webp",
    caption: "Chara design - attitude",
  },
  {
    src: "/concepts/attitude_super_vilain.webp",
    original: "/concepts/attitude_super_vilain.webp",
    caption: "Chara design - super vilain",
  },
  {
    src: "/concepts/expression diana.webp",
    original: "/concepts/expression diana.webp",
    caption: "Chara design - expression Diana",
  },
  {
    src: "/concepts/expression_petit.webp",
    original: "/concepts/expression_petit.webp",
    caption: "Chara design - expression Potit",
  },

  {
    src: "/concepts/lineup.webp",
    original: "/concepts/lineup.webp",
    caption: "Gang lineup",
  },
  {
    src: "/concepts/persoenpidhai.webp",
    original: "/concepts/persoenpidhai.webp",
    caption: "pidhai",
  },
  {
    src: "/concepts/pre_turn.webp",
    original: "/concepts/pre_turn.webp",
    caption: "Chara design - turn",
  },

  {
    src: "/concepts/turn.webp",
    original: "/concepts/turn.webp",
    caption: "Diana turn",
  },
  {
    src: "/concepts/turn_tetess.webp",
    original: "/concepts/turn_tetess.webp",
    caption: "Diana head turn",
  },
  {
    src: "/concepts/wonder.webp",
    original: "/concepts/wonder.webp",
    caption: "wonder",
  },
];
export const paintings = [
  {
    src: "/paintings/Peinture_bananes.webp",
    original: "/paintings/Peinture_bananes.webp",
    caption: "Sous les bananiers",
  },
  {
    src: "/paintings/peintureMurale.webp",
    original: "/paintings/peintureMurale.webp",
    caption: "Peinture Murale",
  },
  {
    src: "/paintings/medusa.webp",
    original: "/paintings/medusa.webp",
    caption: "Street Médusa",
  },
  {
    src: "/paintings/Peinture_banae_1.webp",
    original: "/paintings/Peinture_banae_1.webp",
    caption: "Banana",
  },
  {
    src: "/paintings/toile01.webp",
    original: "/paintings/toile01.webp",
    caption: "Safe place - mise en scène",
  },
  {
    src: "/paintings/miseEnscene.webp",
    original: "/paintings/miseEnscene.webp",
    caption: "Climb, sleep, repeat",
  },
  {
    src: "/paintings/miseEnscene2.webp",
    original: "/paintings/miseEnscene2.webp",
    caption: "Hiding in the threes",
  },
  {
    src: "/paintings/miseEnscene3.webp",
    original: "/paintings/miseEnscene3.webp",
    caption: "Da ba dee da ba di",
  },
  {
    src: "/paintings/miseEnscenecibuste.webp",
    original: "/paintings/miseEnscenecibuste.webp",
    caption: "Cibuste - mise en scène",
  },
  {
    src: "/paintings/20230614_141715.webp",
    original: "/paintings/20230614_141715.webp",
    caption: "Pink power",
  },
  {
    src: "/paintings/Cibuste.webp",
    original: "/paintings/Cibuste.webp",
    caption: "Cibuste",
  },
  {
    src: "/paintings/petitchat2.webp",
    original: "/paintings/petitchat2.webp",
    caption: "Apple is the new rat",
  },
  {
    src: "/paintings/racoon.webp",
    original: "/paintings/racoon.webp",
    caption: "Racoon danse",
  },
  {
    src: "/paintings/toile03.webp",
    original: "/paintings/toile03.webp",
    caption: "Safe place",
  },
  {
    src: "/paintings/totaly.webp",
    original: "/paintings/totaly.webp",
    caption: "Cat & Climb - full collection",
  },
];
export const customs = [
  // public/custom/personnaliser_camille.webp public/custom/personnaliser_effeil.webp public/custom/personnaliser_famille_1.webp public/custom/personnaliser_famille.webp public/custom/personnaliser_farah.webp public/custom/personnaliser_juldev.webp public/custom/personnaliser_mariage.webp public/custom/Personnaliser_MImi.webp public/custom/personnaliser_tazio.webp
  {
    src: "/custom/personnaliser_camille.webp",
    original: "/custom/personnaliser_camille.webp",
    caption: "Gros calin petit chien",
  },
  {
    src: "/custom/personnaliser_effeil.webp",
    original: "/custom/personnaliser_effeil.webp",
    caption: "City of lights",
  },
  {
    src: "/custom/personnaliser_famille.webp",
    original: "/custom/personnaliser_famille.webp",
    caption: "Family time - rock edition",
  },
  {
    src: "/custom/personnaliser_famille_1.webp",
    original: "/custom/personnaliser_famille_1.webp",
    caption: "Family time - river edition",
  },
  {
    src: "/custom/Arthur01.webp",
    original: "/custom/Arthur01.webp",
    caption: "Family time - thug edition",
  },
  {
    src: "/custom/personnaliser_farah.webp",
    original: "/custom/personnaliser_farah.webp",
    caption: "Family time - welcome home",
  },
  {
    src: "/custom/personnaliser_tazio.webp",
    original: "/custom/personnaliser_tazio.webp",
    caption: "Tazio - the kindest dog of the world",
  },
  {
    src: "/custom/personnaliser_mariage.webp",
    original: "/custom/personnaliser_mariage.webp",
    caption: "Wedding day, memories",
  },
  {
    src: "/custom/Personnaliser_MImi.webp",
    original: "/custom/Personnaliser_MImi.webp",
    caption: "Cute little Mimi",
  },
  {
    src: "/custom/personnaliser_juldev.webp",
    original: "/custom/personnaliser_juldev.webp",
    caption: "Happy couple, happy dog",
  },
  {
    src: "/custom/02.webp",
    original: "/custom/02.webp",
    caption: "La chartreuse de slip",
  },
  {
    src: "/custom/mochup05_001.webp",
    original: "/custom/mochup05_001.webp",
    caption: "Sisters love - encadré",
  },
  {
    src: "/custom/LUNAinsta.webp",
    original: "/custom/LUNAinsta.webp",
    caption: "La chartreuse de Luna",
  },
  {
    src: "/custom/Arthur03(1).webp",
    original: "/custom/Arthur03(1).webp",
    caption: "Chill time, good time",
  },
  {
    src: "/custom/Arthur03.webp",
    original: "/custom/Arthur03.webp",
    caption: "Hug meet love",
  },
  {
    src: "/custom/Lapin.webp",
    original: "/custom/Lapin.webp",
    caption: "Little rabbit",
  },
  {
    src: "/custom/Liliane.webp",
    original: "/custom/Liliane.webp",
    caption: "Grandma's model",
  },
  {
    src: "/custom/TempetoImpression.webp",
    original: "/custom/TempetoImpression.webp",
    caption: "La chartreuse de tempête",
  },
  {
    src: "/custom/luna.webp",
    original: "/custom/luna.webp",
    caption: "How cute is she ?",
  },
  {
    src: "/custom/jeu.webp",
    original: "/custom/jeu.webp",
    caption: "Game design - french undercover",
  },

  {
    src: "/custom/sister.webp",
    original: "/custom/sister.webp",
    caption: "Vroom vroom",
  },
  {
    src: "/custom/slip.webp",
    original: "/custom/slip.webp",
    caption: "Insta vs reality",
  },
  {
    src: "/custom/tempete.webp",
    original: "/custom/tempete.webp",
    caption: "Drunk or bored ?",
  },
];

export const modelisations = [
  {
    src: "/modelisations/0000.webp",
    original: "/modelisations/0000.webp",
    caption: "Objet abstrait",
    width: 220,
  },
  {
    src: "/modelisations/CA3_BISCARAT_lea_musee.webp",
    original: "/modelisations/CA3_BISCARAT_lea_musee.webp",
    caption: "Bâtiment historique",
  },
  {
    src: "/modelisations/CA3_BISCARAT_lea_r.webp",
    original: "/modelisations/CA3_BISCARAT_lea_r.webp",
    caption: "Bâtiment moderne",
  },
  {
    src: "/modelisations/Gas_Station1.webp",
    original: "/modelisations/Gas_Station1.webp",
    caption: "Station-service vintage",
  },
  {
    src: "/modelisations/Gas_Station2.webp",
    original: "/modelisations/Gas_Station2.webp",
    caption: "Station-service moderne",
  },
  {
    src: "/modelisations/Gas_Station3.webp",
    original: "/modelisations/Gas_Station3.webp",
    caption: "Station-service futuriste",
  },
  {
    src: "/modelisations/abeillebb.webp",
    original: "/modelisations/abeillebb.webp",
    caption: "Abeille en 3D",
  },
  {
    src: "/modelisations/nature_morte01_02.webp",
    original: "/modelisations/nature_morte01_02.webp",
    caption: "Nature morte en 3D",
  },
  {
    src: "/modelisations/nature_morte_02.webp",
    original: "/modelisations/nature_morte_02.webp",
    caption: "Nature morte en 3D (2)",
  },
  {
    src: "/modelisations/nature_morte_oclusion.webp",
    original: "/modelisations/nature_morte_oclusion.webp",
    caption: "Nature morte occlusion",
  },
  {
    src: "/modelisations/nature_morte_nuit.webp",
    original: "/modelisations/nature_morte_nuit.webp",
    caption: "Nature morte en 3D (nuit)",
  },
  {
    src: "/modelisations/violon05.webp",
    original: "/modelisations/violon05.webp",
    caption: "Violon en 3D",
    width: 444,
  },
];
